<template>
  <v-sheet
    class="smart-home-device-sheet"
    :class="classes"
    :color="color"
    v-bind="$attrs"
  >
    <h3 v-if="showTitle" class="smart-home-device-sheet__title text-h6">
      <slot name="title" :item="smartHomeDevice">
        {{ $t('SMARTHOME_DEVICES.SMART_HOME_DEVICE_DETAILS') }}:
      </slot>
    </h3>

    <p class="smart-home-device-sheet__item">
      <strong>{{ $t('ITEM.ID') }}:</strong>
      {{ smartHomeDevice.id || '' }}
    </p>
    <p class="smart-home-device-sheet__item">
      <strong>{{ $t('BUILDINGS.ITEM') }}:</strong>
      {{ building }}
    </p>
    <p class="smart-home-device-sheet__item">
      <strong>{{ $t('APARTMENTS.ITEM') }}:</strong>
      {{ apartment }}
    </p>
    <p class="smart-home-device-sheet__item">
      <strong>{{ $t('SMARTHOME_DEVICES.MODEL') }}:</strong>
      {{ smartHomeDevice.model || '' }}
    </p>
    <p class="smart-home-device-sheet__item">
      <strong>{{ $t('SMARTHOME_DEVICES.UUID') }}:</strong>
      {{ smartHomeDevice.uuid || '' }}
    </p>
    <p class="smart-home-device-sheet__item">
      <strong>{{ $t('SMARTHOME_DEVICES.OS') }}:</strong>
      {{ smartHomeDevice.os || '' }}
    </p>
    <p class="smart-home-device-sheet__item">
      <strong>{{ $t('SMARTHOME_DEVICES.APP_VERSION') }}:</strong>
      {{ smartHomeDevice.app_version || '' }}
    </p>
    <p class="smart-home-device-sheet__item">
      <strong>{{ $t('ITEM.CREATED_DATE') }}:</strong>
      {{ createdAt }}
    </p>
  </v-sheet>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'SmartHomeDeviceSheet',

  filters: {
    dateFormat
  },

  props: {
    smartHomeDevice: {
      type: Object,
      default: () => ({})
    },
    color: {
      type: String,
      default: 'grey lighten-4'
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes() {
      return {
        'smart-home-device-sheet_small': this.small
      };
    },

    building() {
      const apartment = this.smartHomeDevice.apartment;

      return (apartment && apartment.building && apartment.building.name) || '';
    },

    apartment() {
      const apartment = this.smartHomeDevice.apartment;

      return (apartment && apartment.name) || '';
    },

    createdAt() {
      const date = this.smartHomeDevice.created_at;
      return date ? dateFormat(date) : '';
    }
  }
};
</script>

<style lang="scss">
.smart-home-device-sheet {
  &__item,
  &__title {
    display: block;
    margin-bottom: 1rem;
  }

  &_small &__item,
  &_small &__title {
    display: block;
    margin-bottom: 0.4rem;
  }

  & &__item {
    font-size: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
